import './PopupEmailAlready.scss';

import PropTypes from 'prop-types';
import React from 'react';

import { Link, Text } from '@sitecore-jss/sitecore-jss-react';

const PopupEmailAlready = (props) => {
  const { inputData } = props;

  const onLoginTabHandler = () => {
    props.activeTabLoginEvt();
  };


  return (
    <div className='popup-email-already'>
      {/* <p className='popup-email-already__description text-center'>
        <Text field={inputData['Email Already Exists Message']} />
      </p> */}
      <p className='popup-email-already__description text-center' dangerouslySetInnerHTML={{ __html: inputData['Email Already Exists Message'].value }}></p>
      <div className='popup-email-already__action'>
        <Text onClick={onLoginTabHandler} className='popup-email-already__action__btn popup-email-already__action__btn--login btn btn-outline-CTA1' field={inputData['Login Button Text']} tag='button' />
        { inputData['Continue Gues Checkout Button Text'].value ? (
          <Link className='popup-email-already__action__btn popup-email-already__action__btn--link' field={inputData['Continue Guest Checkout  Button Link']} >
            <Text field={inputData['Continue Gues Checkout Button Text']} />
          </Link>
        ) : (
          <Link className='popup-email-already__action__btn popup-email-already__action__btn--link' field={inputData['Continue Guest Checkout  Button Link']} />
        )}
      </div>
    </div>
  );
};

PopupEmailAlready.propTypes = {
  inputData: PropTypes.object,
  activeTabLoginEvt: PropTypes.func
};

export default PopupEmailAlready;
